// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: YjJSwzSWH26J
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicAddNewClientThroughMenu.module.css"; // plasmic-import: YjJSwzSWH26J/css

createPlasmicElementProxy;

export const PlasmicAddNewClientThroughMenu__VariantProps = new Array();

export const PlasmicAddNewClientThroughMenu__ArgProps = new Array();

const $$ = {};

function PlasmicAddNewClientThroughMenu__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__terXn
        )}
      >
        {"+"}
      </div>
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__q4U5L
        )}
      >
        {"Add New Debtor"}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAddNewClientThroughMenu__ArgProps,
          internalVariantPropNames: PlasmicAddNewClientThroughMenu__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAddNewClientThroughMenu__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAddNewClientThroughMenu";
  } else {
    func.displayName = `PlasmicAddNewClientThroughMenu.${nodeName}`;
  }
  return func;
}

export const PlasmicAddNewClientThroughMenu = Object.assign(
  // Top-level PlasmicAddNewClientThroughMenu renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicAddNewClientThroughMenu
    internalVariantProps: PlasmicAddNewClientThroughMenu__VariantProps,
    internalArgProps: PlasmicAddNewClientThroughMenu__ArgProps
  }
);

export default PlasmicAddNewClientThroughMenu;
/* prettier-ignore-end */
